{
 "1": {
  "kind": "han",
  "romaji": "Riichi",
  "english": "Riichi",
  "closed": 1,
  "open": 0
 },
 "2": {
  "kind": "han",
  "romaji": "Ippatsu",
  "english": "Unbroken",
  "closed": 1,
  "open": 0
 },
 "3": {
  "kind": "han",
  "romaji": "Menzen tsumo",
  "english": "Fully Concealed Hand",
  "closed": 1,
  "open": 0
 },
 "4": {
  "kind": "han",
  "romaji": "Pinfu",
  "english": "Pinfu",
  "closed": 1,
  "open": 0
 },
 "5": {
  "kind": "han",
  "romaji": "Iipeiko",
  "english": "Twin Sequences",
  "closed": 1,
  "open": 0
 },
 "6": {
  "kind": "han",
  "romaji": "Tan'yao",
  "english": "All Inside",
  "closed": 1,
  "open": 1
 },
 "7": {
  "kind": "han",
  "romaji": "Yakuhai haku",
  "english": "Value Honour: White Dragon",
  "closed": 1,
  "open": 1
 },
 "8": {
  "kind": "han",
  "romaji": "Yakuhai hatsu",
  "english": "Value Honour: Green Dragon",
  "closed": 1,
  "open": 1
 },
 "9": {
  "kind": "han",
  "romaji": "Yakuhai chun",
  "english": "Value Honour: Red Dragon",
  "closed": 1,
  "open": 1
 },
 "10": {
  "kind": "han",
  "romaji": "Jikaze",
  "english": "Value Honour: Seat Wind",
  "closed": 1,
  "open": 1
 },
 "11": {
  "kind": "han",
  "romaji": "Bakaze",
  "english": "Value Honour: Round Wind",
  "closed": 1,
  "open": 1
 },
 "12": {
  "kind": "han",
  "romaji": "Chankan",
  "english": "Robbing a Quad",
  "closed": 1,
  "open": 1
 },
 "13": {
  "kind": "han",
  "romaji": "Rinshan kaiho",
  "english": "After a Quad",
  "closed": 1,
  "open": 1
 },
 "14": {
  "kind": "han",
  "romaji": "Haitei",
  "english": "Last Tile Draw",
  "closed": 1,
  "open": 1
 },
 "15": {
  "kind": "han",
  "romaji": "Hotei",
  "english": "Last Tile Claim",
  "closed": 1,
  "open": 1
 },
 "16": {
  "kind": "han",
  "romaji": "Daburu riichi",
  "english": "Double Riichi",
  "closed": 2,
  "open": 0
 },
 "17": {
  "kind": "han",
  "romaji": "Chiitoitsu",
  "english": "Seven Pairs",
  "closed": 2,
  "open": 0
 },
 "18": {
  "kind": "han",
  "romaji": "Ittsu",
  "english": "Full Straight",
  "closed": 2,
  "open": 1
 },
 "19": {
  "kind": "han",
  "romaji": "Sanshoku dojun",
  "english": "Mixed Sequences",
  "closed": 2,
  "open": 1
 },
 "20": {
  "kind": "han",
  "romaji": "Sanshoku doko",
  "english": "Mixed Triplets",
  "closed": 2,
  "open": 2
 },
 "21": {
  "kind": "han",
  "romaji": "Toitoi",
  "english": "All Triplets",
  "closed": 2,
  "open": 2
 },
 "22": {
  "kind": "han",
  "romaji": "San'anko",
  "english": "Three Concealed Triplets",
  "closed": 2,
  "open": 2
 },
 "23": {
  "kind": "han",
  "romaji": "Sankantsu",
  "english": "Three Quads",
  "closed": 2,
  "open": 2
 },
 "24": {
  "kind": "han",
  "romaji": "Chanta",
  "english": "Common Ends",
  "closed": 2,
  "open": 1
 },
 "25": {
  "kind": "han",
  "romaji": "Honroto",
  "english": "Common Terminals",
  "closed": 2,
  "open": 2
 },
 "26": {
  "kind": "han",
  "romaji": "Shosangen",
  "english": "Little Dragons",
  "closed": 2,
  "open": 2
 },
 "27": {
  "kind": "han",
  "romaji": "Ryanpeiko",
  "english": "Double Twin Sequences",
  "closed": 3,
  "open": 0
 },
 "28": {
  "kind": "han",
  "romaji": "Hon'itsu",
  "english": "Common Flush",
  "closed": 3,
  "open": 2
 },
 "29": {
  "kind": "han",
  "romaji": "Junchan",
  "english": "Perfect Ends",
  "closed": 3,
  "open": 2
 },
 "30": {
  "kind": "han",
  "romaji": "Renho",
  "english": "Blessing of Man",
  "closed": 5,
  "open": 0
 },
 "31": {
  "kind": "han",
  "romaji": "Chin'itsu",
  "english": "Perfect Flush",
  "closed": 6,
  "open": 5
 },
 "40": {
  "kind": "yakuman",
  "romaji": "Tenho",
  "english": "Blessing of Heaven",
  "closed": 1,
  "open": 0
 },
 "41": {
  "kind": "yakuman",
  "romaji": "Chiho",
  "english": "Blessing of Earth",
  "closed": 1,
  "open": 0
 },
 "42": {
  "kind": "yakuman",
  "romaji": "Kokushi muso",
  "english": "Thirteen Orphans",
  "closed": 1,
  "open": 0
 },
 "43": {
  "kind": "yakuman",
  "romaji": "Churen poto",
  "english": "Nine Gates",
  "closed": 1,
  "open": 0
 },
 "44": {
  "kind": "yakuman",
  "romaji": "Ryuiso",
  "english": "All Green",
  "closed": 1,
  "open": 1
 },
 "45": {
  "kind": "yakuman",
  "romaji": "Suanko",
  "english": "Four Concealed Triplets",
  "closed": 1,
  "open": 0
 },
 "46": {
  "kind": "yakuman",
  "romaji": "Sukantsu",
  "english": "Four Quads",
  "closed": 1,
  "open": 1
 },
 "47": {
  "kind": "yakuman",
  "romaji": "Chinroto",
  "english": "Perfect Terminals",
  "closed": 1,
  "open": 1
 },
 "48": {
  "kind": "yakuman",
  "romaji": "Tsuiso",
  "english": "All Honours",
  "closed": 1,
  "open": 1
 },
 "49": {
  "kind": "yakuman",
  "romaji": "Daisangen",
  "english": "Big Dragons",
  "closed": 1,
  "open": 1
 },
 "50": {
  "kind": "yakuman",
  "romaji": "Shosushi",
  "english": "Little Winds",
  "closed": 1,
  "open": 1
 },
 "51": {
  "kind": "yakuman",
  "romaji": "Daisushi",
  "english": "Big Winds",
  "closed": 1,
  "open": 1
 },
 "60": {
  "kind": "dora",
  "romaji": "Dora",
  "english": "Dora",
  "closed": 1,
  "open": 1
 },
 "61": {
  "kind": "dora",
  "romaji": "Ura dora",
  "english": "Ura Dora",
  "closed": 1,
  "open": 0
 },
 "62": {
  "kind": "dora",
  "romaji": "Aka dora",
  "english": "Red Five",
  "closed": 1,
  "open": 1
 }
}
